import { useFormik } from 'formik';
import React, { Fragment, useEffect, useState } from 'react';
import { formikAddRoleAccess } from '../Constant';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../components/Loader/Loader';
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import "./Users.css";
import MultiSelect from '../../../components/InputFields/MultiSelect';
import { failed, success } from '../../../utils/Tostify';
import { addStaffRole, getRoles, getStaffs } from '../../../api/User';
import { decryptData } from '../../../utils/helper';
import { platformLayout } from '../../../utils/constants';
import {Form} from 'reactstrap';
import { patientActions } from '../../../context/reducers/patient';

const AddRoleAccessModal = ({setShowModalAddRole, refetch, userId, from, assignedUser, roleData, userData}) => {
    let role = localStorage.getItem("userRole");
    let token = useSelector(state => state.userReducer.token);
    let staffs = useSelector(state => state.patientReducer.staffList);
    const [isLoading, setIsLoading] = useState(false);
    const [RolesOption, setRolesOption] = useState([]);
    const dispatch = useDispatch();
    const formik = useFormik({
        ...formikAddRoleAccess,
        onSubmit: async (values) => {
            let res;
            try {
                setIsLoading(true);
                const payload = {...values, userId : from === "userToRole" ? values?.userId : userId};
                  res = await addStaffRole({values: payload, dispatch, token});
                if (res?.status == "SUCCESS") {
                    await refetch();
                    setIsLoading(false);
                    setShowModalAddRole(false);
                    success(res?.message);
                }else{
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        }
    });

    const getFilteredRoles = (roles, assignedRoles) => {
      const assignedRoleIds = assignedRoles?.map(role => role.value) || [];
      const filteredRoles = roles.filter(role => {
        const isAlreadyAssigned = assignedRoleIds.includes(role._id);
        const isActive = role.active !== false;
        return !isAlreadyAssigned && isActive;
      });
      const mappedRoles = filteredRoles.map(obj => ({
        label: obj.roleName,
        value: obj._id,
        portalLayout: obj.portalLayout
      }));
      return mappedRoles;
    };

    const getRolesList = async (page, limit, searchKey = "") => {
      let res;
      try {
        setIsLoading(true);
        res = await getRoles({ dispatch, token, page, limit, searchKey, dataLimit: "all" });
        const responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
          const filteredRoles = getFilteredRoles(responseData.items, userData.roles);
          setRolesOption(filteredRoles);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        failed(res?.message);
        setIsLoading(false);
      }
    };

    const getStaffList = async (page, limit, searchKey = "") => {
      let res;
      try {
          setIsLoading(true);
          res = await getStaffs({ dispatch, token, page, limit, searchKey});
          const responseData = decryptData(res?.data);
          if (res?.status === "SUCCESS") {
              dispatch(patientActions.staffListing(responseData));
              setIsLoading(false);
          }
      } catch (error) {
          failed(res?.message);
          setIsLoading(false);
      }
  };

  const handleUserSearch=(e, newInputValue, reason)=>{
    if(reason == "input"){
      getStaffList(1, 10, e.target.value);
    }
  };

  const handleRoleSearch = (e, newInputValue, reason) => {
    if (reason === "input") {
      getRolesList(1, 10, e.target.value);
    } else if (reason === "clear") {
      getRolesList(1, 10, ""); // Resetting the search input
    }
  };
  const handleSelect = (userId)=>{
    formik.setFieldValue("userId", userId);
  };

    useEffect(() => {
      from !== "userToRole" ? getRolesList() : getStaffList();
      from === "userToRole" ? formik.setFieldValue("roles", [{lable: roleData?.roleName, value: roleData?._id}]) : [];
    }, []);

    const assignedStaffIds = assignedUser?.map(item => item._id) || [];
    const options = staffs?.items
    ?.filter((obj) => !assignedStaffIds.includes(obj._id) && obj?.active)
    ?.map((obj) => {
        return {
            label: obj?.firstName + " " + obj?.lastName,
            value: obj._id
        };
    });
    useEffect(() => {
      if (setShowModalAddRole) {
        const modalBody = document.querySelector('.assign_modal_body');
        if (modalBody) {
          modalBody.scrollTop = 0;
        }
      }
    }, [setShowModalAddRole]);


  return (
    <Fragment>
        <Modal isOpen={setShowModalAddRole} toggle={setShowModalAddRole} size="xl">
        <ModalHeader toggle={setShowModalAddRole} className="assign_blk p-0 mb-3">{from !== "userToRole" ? "Add Role Access" : "Add User Access"}</ModalHeader>
        <Form onSubmit={formik.handleSubmit}>
          <ModalBody className="assign_modal_body">
          {isLoading ? <Loader /> : null}
              <div className="first_block second_block">
                  {from !== "userToRole" ? (<Row className='m-0'>
                    <Col lg={12} className="location_block mb-3 p-0">
                        <MultiSelect
                          keyField={"roles"}
                          formik={formik}
                          label="User Roles"
                          options={(role == platformLayout.Platform) ? RolesOption : RolesOption.filter((obj)=> obj?.portalLayout !== platformLayout.Platform)}
                          type="select"
                          placeholder="Search Role"
                          value={formik.values.roles}
                          handleInput={(e, newInputValue, reason)=> handleRoleSearch(e, newInputValue, reason)}
                          autoFocus={true}
                        />
                    </Col>
                  </Row>) :
                  (<Row className='m-0'>
                  <Col lg={12} className="location_block mb-3 p-0">
                      <MultiSelect
                          keyField={"userId"}
                          multiple={false}
                          formik={formik}
                          label="Select User"
                          options={options?.length > 0 ? options : []}
                          type="select"
                          placeholder="Search User"
                          value={formik?.values?.userId}
                          handleInput={(e, newInputValue, reason)=> handleUserSearch(e, newInputValue, reason)}
                          onChange={handleSelect}
                      />
                  </Col>
                  </Row>)}
              </div>
          </ModalBody>
          <ModalFooter>
          <div className="d-flex justify-content-between">
                  <button className="save_btn" onClick={setShowModalAddRole}>Close</button>
                  <button className="save_btn" type="submit">Save</button>
              </div>
          </ModalFooter>
        </Form>
        </Modal>
  </Fragment>
  );
};

export default AddRoleAccessModal;
